import { Stack, Typography } from "@mui/material";
import WushCard from "../../layout/WushCard";

export default function LocationCard({ location }) {
  return (
    <Stack>
      <WushCard>
        <Stack p={2}>
          <Stack>
            <Stack>
              <Typography variant="h5">{location.name}</Typography>
            </Stack>
            <Stack>
              <Typography variant="body1">{location.address_1}, {location.city} {location.zip}</Typography>
            </Stack>
          </Stack>
        </Stack>
      </WushCard>
    </Stack>
  );
}